import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: any) => {
  return request.post({ url: '/admin/auth/login', data })
}
export const getSmsCode = (data: any) => {
  return request.post({ url: '/admin/auth/regCaptcha', data })
}
// 获取用户信息
export const getInfoApi = (): Promise<IResponse<UserType>> => {
  return request.get({ url: '/admin/auth/info' })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/admin/auth/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/admin/menu/getRouters', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
